<div>
    <h5 class="text-start text-primary fw-bold ps-2 ms-1 my-4">Enter Permanent (Indian) Address Details</h5>
     <div class="col-12 mt-3 pe-lg-5 ps-lg-2 pe-md-2" *ngIf="mandatory">
        <p class="text-danger fw-bold">Request you to complete the Permanent Address stage, as Indian proof is mandatory to proceed in the journey</p>
        
     </div>
    <div class="col-12 mt-3 pe-lg-5 ps-lg-2 pe-md-2" *ngIf="NRO ==='Y'">
        <b>To fetch your Indian address using Aadhaar, your mobile number must be linked to your Aadhaar. Is your mobile
            linked with Aadhaar?</b>
        <div class="d-flex gap-3 mt-3">
            <div>
                <input class="ms-0 form-check-input" type="radio" name="DigiOptionval" [(ngModel)]="DigiOptionval"
                    value="Y" id="Pyes" [disabled]="digi||completestage" (change)="DigiOption('Y')">
                <label class="form-check-label ps-2" for="Pyes">Yes</label>
            </div>
            <div>
                <input class="ms-lg-3 form-check-input" type="radio" name="DigiOptionval" [(ngModel)]="DigiOptionval"
                    value="N" id="Pno" [disabled]="digi||completestage" (change)="DigiOption('N')">
                <label class="form-check-label ps-2" for="Pno">No</label>
            </div>
        </div>
    </div>
    <div class="mt-5" *ngIf="((NRO ==='Y' && permanentoption)||(NRO !=='Y'))">
        <!-- <div class="mt-5"> -->
        <form [formGroup]="addressForm" novalidate>
            <div class="row mx-0 mt-2">
                <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                    <div class="form-floating"
                        [ngClass]="addressForm.controls.DocType.touched && addressForm.controls.DocType.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                        <select class="form-select"
                            [ngClass]="addressForm.controls.DocType.value ? 'optionValue has-value' : ''"
                            formControlName="DocType" id="docType" (change)="docError = false; checkType($event)"
                            tabindex="1">
                            <option *ngFor="let list of docTypeList; let i = index" [value]="list.DocumentTypeId">
                                {{list.Name}}</option>
                        </select>
                        <label *ngIf="addressForm.controls.DocType.value"
                            [ngClass]="addressForm.controls.DocType.value ? '':'form-select-label'"
                            for="docType">Address Proof Type <span class="text-danger">*</span></label>
                        <label *ngIf="!addressForm.controls.DocType.value" for="docType"
                            class="form-select-label">Select Address Proof Type <span
                                class="text-danger">*</span></label>
                        <div class="text-danger small ms-3 mt-0" *ngIf="docError">
                            Please select document type
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                    <div class="form-floating"
                        [ngClass]="addressForm.controls.Country.touched && addressForm.controls.Country.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                        <select class="form-select text-uppercase"
                            [ngClass]="addressForm.controls.Country.value ? 'has-value':''" formControlName="Country"
                            id="country" tabindex="2">
                            <option [value]="list.Name" *ngFor="let list of countryList; let i = index">{{list.Name}}
                            </option>
                        </select>
                        <label *ngIf="addressForm.controls.Country.value"
                            [ngClass]="addressForm.controls.Country.value ? '' : 'form-select-label'"
                            for="country">Select Country <span class="text-danger">*</span></label>
                        <label *ngIf="!addressForm.controls.Country.value" for="country"
                            class="form-select-label">Select Country <span class="text-danger">*</span></label>
                    </div>
                </div>
                <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                    <div [ngClass]="perAdrImgempty ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                        <nri-app-img-upld *ngIf="!previousDocs" [imageName]="'Permanent Address Front'"
                            [docTypeID]="addressForm.controls.DocType.value" (docTypeError)="typeError($event)"
                            (getdocTypeID)="getID($event)" (imageURL)="imageURL($event)" #perAdrimg
                            [changeID]="changeIDs" [change]="changeDoc" (getOcrDatas)="getOCR($event)"
                            [disabled]="digi"></nri-app-img-upld>
                        <div *ngIf="previousDocs"
                            class="drop-container flex-column d-flex justify-content-center text-center mb-4">
                            <p class="upload-button mt-2 mb-2 px-2 small">
                                Since you have already uploaded your {{docName}} front image, re-uploading the document
                                is not necessary.
                            </p>
                        </div>
                        <div class="text-danger small" *ngIf="perAdrImgempty">
                            Please upload your address proof front image
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0" *ngIf="!digi">
                    <div [ngClass]="perAdrImgempty1 ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                        <nri-app-img-upld *ngIf="!previousDocs" [imageName]="'Permanent Address Back'"
                            [docTypeID]="addressForm.controls.DocType.value" (docTypeError)="typeError($event)"
                            (getdocTypeID)="getID($event)" (imageURL)="imageURL($event)" #perAdrimg1
                            [changeID]="changeIDs" [change]="changeDoc" (getOcrDatas)="getOCR($event)"
                            [disabled]="digi"></nri-app-img-upld>
                        <div *ngIf="previousDocs"
                            class="drop-container flex-column d-flex justify-content-center text-center mb-4">
                            <p class="upload-button mt-2 mb-2 px-2 small">
                                Since you have already uploaded your {{docName}} back image, re-uploading the document
                                is not necessary.
                            </p>
                        </div>
                        <div class="text-danger small" *ngIf="perAdrImgempty1">
                            Please upload your address proof back image
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0" *ngIf="digi">

                </div>
                <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                    <div class="form-floating"
                        [ngClass]="addressForm.controls.AddressLine1.touched && addressForm.controls.AddressLine1.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                        <input type="text" class="form-control" formControlName="AddressLine1"
                            [ngClass]="addressForm.controls.AddressLine1.value ? 'has-value':''" autocomplete="off"
                            minlength="5" maxlength="100" id="adr1" placeholder="Address Line 1" tabindex="3"
                            (input)="onInputChanged($event)">
                        <label for="adr1">Enter Address Line 1 <span class="text-danger">*</span></label>
                        <div *ngIf="addressForm.controls.AddressLine1.touched && addressForm.controls.AddressLine1.errors"
                            class="ms-3 mt-0">
                            <span class="small text-danger">Please enter address line 1.</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0 order-3 order-md-0">
                    <div class="form-floating"
                        [ngClass]="addressForm.controls.State.touched && addressForm.controls.State.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                        <select class="form-select text-uppercase"
                            [ngClass]="addressForm.controls.State.value ? 'has-value' : ''" formControlName="State"
                            id="state" tabindex="6">
                            <option [value]="state.State" *ngFor="let state of stateList">{{state.State}}</option>
                        </select>
                        <label *ngIf="addressForm.controls.State.value"
                            [ngClass]="addressForm.controls.State.value ? '' : 'form-select-label'" for="state">Select
                            State <span class="text-danger">*</span></label>
                        <label *ngIf="!addressForm.controls.State.value" for="state" class="form-select-label">Select
                            State <span class="text-danger">*</span></label>
                        <div *ngIf="addressForm.controls.State.touched && addressForm.controls.State.errors"
                            class="ms-3 mt-0">
                            <span class="small text-danger">Please select a state.</span>
                        </div>
                    </div>
                    <!-- <div class="form-floating" [ngClass]="addressForm.controls.State.touched && addressForm.controls.State.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                        <input type="text" class="form-control text-uppercase" formControlName="State" [ngClass]="addressForm.controls.State.value ? 'has-value':''" autocomplete="off" maxlength="45" id="state" tabindex="6" placeholder="State" appAlphabetsOnly>
                        <label for="state">Select State <span class="text-danger">*</span></label>
                        <div *ngIf="addressForm.controls.State.touched && addressForm.controls.State.errors" class="ms-3 mt-0">
                            <span class="small text-danger">Please enter State name.</span>
                        </div>
                    </div> -->
                </div>
                <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                    <div class="form-floating"
                        [ngClass]="addressForm.controls.AddressLine2.touched && addressForm.controls.AddressLine2.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                        <input type="text" class="form-control" formControlName="AddressLine2"
                            [ngClass]="addressForm.controls.AddressLine2.value ? 'has-value':''" autocomplete="off"
                            tabindex="4" minlength="5" maxlength="100" id="adr2" placeholder="Address Line 2"
                            (input)="onInputChanged($event)">
                        <label for="adr2">Enter Address Line 2<span class="text-danger">*</span></label>
                        <div *ngIf="addressForm.controls.AddressLine2.touched && addressForm.controls.AddressLine2.errors"
                            class="ms-3 mt-0">
                            <span class="small text-danger">Please enter address line 2.</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0 order-4 order-md-0">
                    <div class="form-floating"
                        [ngClass]="addressForm.controls.City.touched && addressForm.controls.City.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                        <input type="text" class="form-control text-uppercase" tabindex="7"
                            [ngClass]="addressForm.controls.City.value ? 'has-value':''" formControlName="City"
                            autocomplete="off" maxlength="45" id="city" placeholder="City" appAlphabetsOnly>
                        <label for="city">Select City <span class="text-danger">*</span></label>
                    </div>
                    <div *ngIf="addressForm.controls.City.touched && addressForm.controls.City.errors"
                        class="ms-3 mt-0">
                        <span class="small text-danger">Please enter valid city.</span>
                    </div>
                </div>
                <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0">
                    <div class="form-floating"
                        [ngClass]="addressForm.controls.AddressLine3.touched && addressForm.controls.AddressLine3.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                        <input type="text" class="form-control" formControlName="AddressLine3" tabindex="5"
                            [ngClass]="addressForm.controls.AddressLine3.value ? 'has-value':''" autocomplete="off"
                            minlength="5" maxlength="100" id="adr3" placeholder="Address Line 3"
                            (input)="onInputChanged($event)">
                        <label for="adr3">Enter Address Line 3 <span class="text-danger">*</span></label>
                        <div *ngIf="addressForm.controls.AddressLine3.touched && addressForm.controls.AddressLine3.errors"
                            class="ms-3 mt-0">
                            <span class="small text-danger">Please enter address line 3.</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0 order-5 order-md-0">
                    <div class="form-floating"
                        [ngClass]="addressForm.controls.PinCode.touched && addressForm.controls.PinCode.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                        <input type="text" class="form-control" formControlName="PinCode" tabindex="8"
                            [ngClass]="addressForm.controls.PinCode.value ? 'has-value':''" autocomplete="off"
                            maxlength="20" id="PinCode" placeholder="Pin Code" appAlphanumeric>
                        <label for="PinCode">Enter Pincode\ZIP code
                            <span class="text-danger">*</span>
                        </label>
                        <div *ngIf="addressForm.controls.PinCode.touched && addressForm.controls.PinCode.errors"
                            class="ms-3 mt-0">
                            <span class="small text-danger">Please enter Pincode\ZIP code.</span>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0 order-5 order-md-0">
                    <div class="form-floating"
                        [ngClass]="addressForm.controls.DocNumber.touched && addressForm.controls.DocNumber.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                        <input type="text" tabindex="9" class="form-control"
                            [ngClass]="addressForm.controls.DocNumber.value ? 'has-value':''"
                            formControlName="DocNumber" autocomplete="off" maxlength="20" id="DocNumber"
                            placeholder="Document Number" appAlphanumeric (blur)="spaceValidation($event, 'DocNumber')">
                        <label for="DocNumber">Enter Address Proof Number
                            <span class="text-danger">*</span>
                        </label>
                        <div *ngIf="addressForm.controls.DocNumber.touched && addressForm.controls.DocNumber.errors"
                            class="ms-3 mt-0">
                            <span class="small text-danger">Please Enter Address Proof Number.</span>
                        </div>
                    </div>
                </div> -->

            </div>
        </form>
        <div class="row mx-0 mt-2">
        <div class="col-lg-6 pe-lg-5 pe-md-2 ps-md-2 px-0 order-5 order-md-0">
            <div class="form-floating"
                [ngClass]="docNumber?.touched && docNumber?.invalid ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">

                <input type="text" tabindex="9" class="form-control" [ngClass]="docNumber?.value ? 'has-value':''"
                    name="DocNumber" [(ngModel)]="docNumberValue" #docNumber="ngModel" required maxlength="20"
                    id="DocNumber" placeholder="Document Number" appAlphanumeric
                    (blur)="spaceValidation($event, 'DocNumber')">

                <label for="DocNumber">
                    Enter Address Proof Number <span class="text-danger">*</span>
                </label>

                <div *ngIf="docNumber?.touched && docNumber?.invalid" class="ms-3 mt-0">
                    <span class="small text-danger">Please Enter Address Proof Number.</span>
                </div>
            </div>
        </div>
        <div class="col-lg-6 pe-md-5" *ngIf="datesection">
            <div class="input-group border form-floating mb-4 rounded-2">
                <input class="form-control ms-0 my-1 border-0 pe-0 py-0" [(ngModel)]="lastArrivalDt" readonly
                    placeholder="Enter Last Arrival in India" ngx-mydatepicker (click)="dp.toggleCalendar()"
                    name="mydate" [options]="options2" [defaultMonth]="defaultMonth.defMonth" id="pExpiry"
                    #dp="ngx-mydatepicker" (dateChanged)="onDateArrival($event)" required />
                <label for="pExpiry">Select Expiry Date<span class="text-danger">*</span></label>
                <span class="px-3 py-2">
                    <img src="./assets/images/Calendar.svg" (click)="dp.toggleCalendar()">
                </span>
            </div>
            <div *ngIf="arrivalDateError">
                <span class="small text-danger">Expiry Date should be above 60 days.</span>
            </div>
        </div>
        </div>
    </div>

    <div class="d-flex align-items-end  mx-0 mt-5 pt-5 row">
        <div class="col-6 p-0">
            <button class="btn btn-white border-primary text-primary px-4" (click)="backStage()">Back</button>
        </div>
        <div class="col-6 p-0 text-end pe-md-3">
            <button class="btn btn-primary px-4" *ngIf="sameAddress !== 'Y'"
                [disabled]="!addressForm.valid && mandatory && !digi" (click)="stageValidate()">Next</button>
            <button class="btn btn-primary px-4" *ngIf="sameAddress === 'Y'" (click)="stageValidate()">Next</button>
        </div>
    </div>
</div>


<div class="modal fade" id="redirect" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0">
                <p class="h5">Welcome to SBI Securities</p>

            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <strong>You are not allowed continue the Journey! If you select Passport as your Document
                            Proof!</strong>
                    </div>
                </div>
            </div>
            <div class="modal-footer row mx-0">
                <div class="col-6 m-0">
                    <!-- <button type="button" class="btn btn-google px-4 fw-bold w-100 py-2" data-bs-dismiss="modal">NO</button> -->
                </div>
                <div class="col-md-6 m-0">
                    <button type="button" class="btn btn-primary px-4 fw-bold w-100 py-2" data-bs-dismiss="modal"
                        (click)="goTo()">Click To Change</button>
                </div>
            </div>
        </div>
    </div>
</div>

<ngx-ui-loader></ngx-ui-loader>
<app-error-modal #errorComp></app-error-modal>